/*global define*/
define(function() {

        'use strict';

       return {
           lang : "EN",

           config: {
               contextSystem :"fenix_develop",
               datasources : ["D3S"],
               resourceRepresentationType: "dataset"
           },

           copyMeta: true,
           copyDSD: true,

           menuItems : ['home', 'landing', 'search', 'add', 'metadata', 'dsd', 'data', 'delete', 'close'],
           menuItemsEnabledOnStart : ['add', 'search', 'landing'],
           menuItemsEnableOnValidResource : ['delete', 'metadata', 'dsd', 'data', 'home', 'close']
       };

    }
);


//////////////////
// WEBPACK FOOTER
// ./src/config/config.js
// module id = 37
// module chunks = 0